export default api => ({
  getInfo: () => api.get('/killswitches'),
  update: (data) => api.patch('/killswitches', data),
  forceBatchProcessing: () => api.post('/killswitches/process-transactions'),
  getBatchProcessingStatus: () => api.get('/killswitches/is-batch-process'),
})
